import { render, staticRenderFns } from "./VitalSignDialog.vue?vue&type=template&id=72540cfc&scoped=true"
import script from "./VitalSignDialog.vue?vue&type=script&lang=js"
export * from "./VitalSignDialog.vue?vue&type=script&lang=js"
import style0 from "./VitalSignDialog.vue?vue&type=style&index=0&id=72540cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72540cfc",
  null
  
)

export default component.exports